export const getContent = (state, getters, rootState) => {
  const packageName = rootState.simulation.package;

  if (!packageName) {
    return null;
  }

  const parentPackage = packageName.indexOf('.') >= 0 ? packageName.split('.')[0] : null;

  const filteredContent = state.content.filter(relationship => relationship.scope === '*' || relationship.scope === packageName || (parentPackage && relationship.scope === parentPackage));

  return filteredContent;
};

export default {
  getContent
};



// WEBPACK FOOTER //
// ./src/store/modules/relationships/getters.js